export default __webpack_public_path__ + "static/media/m2-01.3f3cd6f7.png";